/* Trueon — theme scripts (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      const parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    };
    const match = format.match(placeholder);
    if (!match) return format;
    let value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    value = value.replace(/[.,]00$/, ''); // $89.00 -> $89 (keeps $89.50)
    return format.replace(placeholder, value);
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      const msgs = $$('.announcement__message', bar);
      if (msgs.length < 2) return;
      let i = 0;
      setInterval(() => {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, parseInt(bar.dataset.speed, 10) || 5000);
    });
  }

  /* ---------- Header: drawer + search ---------- */
  function initHeader() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        const drawer = document.getElementById(opener.dataset.drawerOpen);
        if (!drawer) return;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('no-scroll');
        const focusable = drawer.querySelector('button, a');
        if (focusable) focusable.focus();
        return;
      }
      const closer = e.target.closest('[data-drawer-close]');
      if (closer) closeDrawers();

      const searchToggle = e.target.closest('[data-search-toggle]');
      if (searchToggle) {
        const panel = document.getElementById('HeaderSearch');
        if (!panel) return;
        const open = panel.hasAttribute('hidden');
        panel.toggleAttribute('hidden', !open);
        $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
        if (open) $('input[type="search"]', panel).focus();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeDrawers();
      closeVideo();
      const panel = document.getElementById('HeaderSearch');
      if (panel) panel.setAttribute('hidden', '');
    });
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    $$('[data-drawer-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('no-scroll');
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    $$('[data-slider]', root).forEach((slider) => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      const slides = $$('.hero__slide', slider);
      const dots = $$('.hero__dot', slider);
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const go = (n) => {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (n + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      };
      const start = () => {
        if (slider.dataset.autoplay !== 'true') return;
        stop();
        timer = setInterval(() => go(index + 1), parseInt(slider.dataset.speed, 10) || 6000);
      };
      const stop = () => clearInterval(timer);
      slider.addEventListener('click', (e) => {
        if (e.target.closest('[data-slide-prev]')) { go(index - 1); start(); }
        if (e.target.closest('[data-slide-next]')) { go(index + 1); start(); }
        const dot = e.target.closest('[data-slide-to]');
        if (dot) { go(parseInt(dot.dataset.slideTo, 10)); start(); }
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      // Touch swipe
      let x0 = null;
      slider.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); start(); }
        x0 = null;
      });
      // Allow theme editor to select a slide
      slider.addEventListener('shopify:block:select', (e) => {
        const i = slides.indexOf(e.target);
        if (i > -1) { stop(); go(i); }
      });
      start();
    });
  }

  /* ---------- Scroll carousels ---------- */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = $('[data-carousel-track]', wrap);
      const prev = $('[data-carousel-prev]', wrap);
      const next = $('[data-carousel-next]', wrap);
      if (!track) return;
      const step = () => {
        const item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Video modal ---------- */
  function initVideos() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-video-open]');
      if (btn) {
        const card = btn.closest('[data-video-item]');
        const tpl = card && $('template[data-video-template]', card);
        const modal = document.getElementById('VideoModal');
        if (!tpl || !modal) return;
        const content = $('[data-video-content]', modal);
        content.innerHTML = '';
        content.appendChild(tpl.content.cloneNode(true));
        modal.hidden = false;
        document.body.classList.add('no-scroll');
        const video = $('video', content);
        if (video) video.play().catch(() => {});
        $('.video-modal__close', modal).focus();
        modal._returnFocus = btn;
        return;
      }
      if (e.target.closest('[data-video-close]')) closeVideo();
    });
  }
  function closeVideo() {
    const modal = document.getElementById('VideoModal');
    if (!modal || modal.hidden) return;
    $('[data-video-content]', modal).innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('no-scroll');
    if (modal._returnFocus) modal._returnFocus.focus();
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-qty-minus]');
      const plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      const input = $('input', e.target.closest('[data-quantity]'));
      const min = parseInt(input.min, 10) || 0;
      const val = parseInt(input.value, 10) || 0;
      input.value = Math.max(min, val + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Cart: AJAX add + count + toast ---------- */
  let toastTimer;
  function showToast(item) {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    $('[data-toast-title]', toast).textContent = item.product_title + (item.variant_title ? ' — ' + item.variant_title : '');
    const media = $('[data-toast-media]', toast);
    media.innerHTML = '';
    if (item.image) {
      const img = document.createElement('img');
      img.alt = '';
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      media.appendChild(img);
    }
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4500);
  }
  function hideToast() {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(() => { toast.hidden = true; }, 350);
  }
  function updateCount() {
    return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
          el.classList.remove('bump');
          void el.offsetWidth;
          el.classList.add('bump');
        });
      });
  }
  function initProductForms() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      const button = $('[type="submit"]', form);
      const errorEl = $('[data-form-error]', form);
      if (errorEl) errorEl.hidden = true;
      if (button) button.classList.add('is-loading');
      fetch(window.theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'Could not add to bag');
          /* Bundle free gift: add the selected card's gift variant once per cart */
          var giftInput = form.querySelector('.pp-bcard input:checked');
          var giftId = giftInput ? parseInt(giftInput.dataset.bundleGift, 10) : 0;
          if (!giftId) return data;
          return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((cart) => {
              if (cart.items && cart.items.some((it) => it.variant_id === giftId)) return data;
              return fetch(window.theme.routes.cartAdd + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: giftId, quantity: 1, properties: { _bundle_gift: '1' } }] })
              }).then(() => data);
            })
            .catch(() => data);
        })
        .then((data) => {
          var added = data.items ? data.items[0] : data;
          if (document.querySelector('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) { refreshDrawer(true); }
          else { showToast(added); }
          if (typeof window.fbq === 'function' && added) {
            window.fbq('track', 'AddToCart', { content_ids: [String(added.variant_id || added.id)], content_name: added.product_title, content_type: 'product', value: (added.final_line_price || added.price * (added.quantity || 1)) / 100, currency: window.theme_currency || 'USD' });
          }
          return updateCount();
        })
        .catch((err) => {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          else alert(err.message);
        })
        .finally(() => { if (button) button.classList.remove('is-loading'); });
    });
    document.addEventListener('click', (e) => { if (e.target.closest('[data-toast-close]')) hideToast(); });
  }

  /* ---------- Pixel: InitiateCheckout ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (!b || typeof window.fbq !== 'function') return;
    fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) {
      window.fbq('track', 'InitiateCheckout', { value: c.total_price / 100, currency: c.currency, num_items: c.item_count });
    }).catch(function () {});
  }, true);



  /* ---------- Express checkout label: list the shopper's own wallet first ---------- */
  function expressLabel() {
    var ua = navigator.userAgent || '';
    var isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isMacSafari = /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|Edg|Firefox/.test(ua);
    if (isIOS || isMacSafari) return 'Apple Pay · Shop Pay · PayPal';
    if (/Android/.test(ua)) return 'Google Pay · Shop Pay · PayPal';
    return 'Shop Pay · PayPal · Google Pay';
  }
  function applyExpressLabel(root) {
    (root || document).querySelectorAll('[data-express-names]').forEach(function (el) { el.textContent = expressLabel(); });
  }

  /* ---------- Cart drawer ---------- */
  function drawerEl() { return document.querySelector('[data-cart-drawer]'); }
  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var c = d.querySelector('[data-cart-close]:not(.cd__overlay)'); if (c) c.focus();
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  function refreshDrawer(open) {
    var d = drawerEl(); if (!d) return Promise.resolve();
    d.classList.add('is-loading');
    return fetch(window.theme.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var fresh = tmp.querySelector('.cd__panel');
        var cur = d.querySelector('.cd__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        applyExpressLabel(d);
        d.classList.remove('is-loading');
        if (open) openDrawer();
      })
      .catch(function () { d.classList.remove('is-loading'); window.location.href = window.theme.routes.cart; });
  }
  function initDrawer() {
    var d = drawerEl(); if (!d) return;
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('.header__cart');
      if (cartLink && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer(); return; }
      if (!d.contains(e.target)) return;
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var ex = e.target.closest('[data-express-toggle]');
      if (ex) { var box = ex.closest('[data-express]'); var open = !box.classList.contains('is-open'); box.classList.toggle('is-open', open); ex.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
      var q = e.target.closest('[data-cart-qty]');
      if (q) {
        var line = q.closest('[data-line]').dataset.line;
        d.classList.add('is-loading');
        fetch(window.theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(q.dataset.cartQty, 10) }) })
          .then(function () { return refreshDrawer(false); }).then(updateCount);
        return;
      }
      var add = e.target.closest('[data-cart-add-id]');
      if (add) {
        d.classList.add('is-loading');
        fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(add.dataset.cartAddId, 10), quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var it = res.items && res.items[0];
            if (it && typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [String(it.variant_id)], content_name: it.product_title, content_type: 'product', value: it.final_line_price / 100, currency: window.theme_currency || 'USD' });
            return refreshDrawer(false);
          }).then(updateCount);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Cart page auto-update ---------- */
  function initCartPage() {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(() => {
        form.closest('.cart').classList.add('is-updating');
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'update';
        hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }, 500);
    });
  }

  /* ---------- Product page: variants + gallery ---------- */
  function initProduct(root) {
    $$('[data-product-section]', root).forEach((section) => {
      const gallery = $('[data-gallery]', section);
      const showMedia = (id) => {
        if (!gallery || !id) return;
        $$('.product__slide', gallery).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
        $$('[data-thumb]', gallery).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
        $$('.product__slide video', gallery).forEach((v) => v.pause());
      };
      if (gallery) {
        gallery.addEventListener('click', (e) => {
          const thumb = e.target.closest('[data-thumb]');
          if (thumb) showMedia(thumb.dataset.thumb);
        });
      }

      const picker = $('[data-variant-picker]', section);
      if (!picker) return;
      const variants = JSON.parse($('[data-variants-json]', picker).textContent);
      const form = $('[data-product-form]', section);
      const idInput = form && $('[data-variant-id]', form);
      const addBtn = form && $('[data-add-button]', form);
      const addLabel = form && $('[data-add-label]', form);
      const priceEl = $('[data-price]', section);
      const compareEl = $('[data-compare-price]', section);
      const priceWrap = $('[data-price-wrapper]', section);

      const selected = () => $$('fieldset', picker).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });

      const markAvailability = (current) => {
        $$('input[type="radio"]', picker).forEach((input) => {
          const idx = parseInt(input.dataset.optionIndex, 10);
          const opts = current.slice();
          opts[idx] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
          input.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
        });
      };

      const onChange = () => {
        const opts = selected();
        $$('[data-option-value]', picker).forEach((el, i) => { el.textContent = opts[i]; });
        markAvailability(opts);
        const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = window.theme.strings.unavailable;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          const onSale = variant.compare_at_price > variant.price;
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          if (priceWrap) priceWrap.classList.toggle('price--sale', onSale);
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      };
      picker.addEventListener('change', onChange);
      markAvailability(selected());
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    const form = document.querySelector('[data-filter-form]');
    if (!form) return;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-auto-submit]')) return;
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) { if (v === '') params.delete(k); }
      window.location.search = params.toString();
    });
    document.addEventListener('click', (e) => {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      $$('[data-filter][open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- Related products (lazy load) ---------- */
  function initRelated() {
    $$('[data-related]').forEach((el) => {
      const load = () => fetch(el.dataset.url)
        .then((r) => r.text())
        .then((html) => {
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const inner = tmp.querySelector('[data-related]');
          if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
        })
        .catch(() => {});
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- Login: recover toggle ---------- */
  function initLogin() {
    const loginPanel = $('[data-login-panel]');
    const recoverPanel = $('[data-recover-panel]');
    if (!loginPanel || !recoverPanel) return;
    const toggle = (showRecover) => { loginPanel.hidden = showRecover; recoverPanel.hidden = !showRecover; };
    if (window.location.hash === '#recover') toggle(true);
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-toggle-recover]')) return;
      e.preventDefault();
      toggle(loginPanel.hidden === false);
    });
  }

  /* ---------- Localization selector ---------- */
  function initLocalization() {
    document.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-localization-select]');
      if (sel) sel.form.submit();
    });
  }

  /* ---------- Hero videos: pause when not visible ---------- */
  function initHeroVideos() {
    const vids = $$('.hero__video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) en.target.play().catch(() => {}); else en.target.pause(); });
    });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------- Country selects default ---------- */
  function initCountrySelects() {
    $$('select[data-default]').forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    const targets = $$('.card, .video-card, .creator-card, .tile, .product-card, .section-head, .trust-bar__item, .image-text__grid > *', root);
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach((el, i) => {
      if (el.dataset.reveal !== undefined) return;
      el.setAttribute('data-reveal', '');
      el.style.transitionDelay = (i % 5) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Boot ---------- */
  function initSection(root) {
    initHero(root);
    initCarousels(root);
    initProduct(root);
    initReveal(root);
  }
  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncement();
    initHeader();
    initVideos();
    initQuantity();
    initProductForms();
    initDrawer();
    applyExpressLabel();
    initCartPage();
    initFilters();
    initRelated();
    initLogin();
    initCountrySelects();
    initLocalization();
    initHeroVideos();
    initSection(document);
  });
  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initSection(e.target));

  window.Trueon = { formatMoney: formatMoney, refreshCart: refreshDrawer, updateCount: updateCount };
})();
